module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point2_5-3d7b77c5258cb2217c07b269a56e852c.jpg";